/**
 * Parola + tekrar. Kısa parola ENGELLENMEZ, uyarılır (kullanıcı kararı D1):
 * bulut yedeği kopyalanıp tahminle açılmaya çalışılabilir.
 *
 * İSTİSNA — `sart` (kullanıcı kararı 18.10.2026): "Parolamı unuttum" ile
 * yeni parola belirlenirken en az 12 karakter ŞART, kasadan ve yedek
 * hedefinden bağımsız. Uyarı o zaman bir engel cümlesi olur.
 */

import { M } from "../../dil";
import { PAROLA_UYARI_UZUNLUGU } from "@parafon/contracts/local-api";
import { Field, Notice, TextInput } from "../../ui/primitives";

export interface ParolaDegeri {
  readonly parola: string;
  readonly tekrar: string;
}

/** Gönderilebilir mi; değilse sebebi. */
export function parolaSorunu(d: ParolaDegeri, sart = false): string | null {
  if (d.parola.length === 0) return M.kilit.parolaAlan.bos;
  if (sart && [...d.parola].length < PAROLA_UYARI_UZUNLUGU) {
    return M.kilit.parolaAlan.enAz(PAROLA_UYARI_UZUNLUGU);
  }
  if (d.parola !== d.tekrar) return M.kilit.parolaAlan.ayniDegil;
  return null;
}

export function ParolaAlanlari({
  deger,
  onDegis,
  etiket = M.kilit.parola,
  kimlik = "kilit-parola",
  sart = false,
}: {
  readonly deger: ParolaDegeri;
  readonly onDegis: (d: ParolaDegeri) => void;
  readonly etiket?: string;
  readonly kimlik?: string;
  /** true: 12 karakter uyarı değil şart (parolamı unuttum). */
  readonly sart?: boolean;
}) {
  const kisa = deger.parola.length > 0 && [...deger.parola].length < PAROLA_UYARI_UZUNLUGU;
  return (
    <div className="space-y-3">
      <div className="grid gap-3 sm:grid-cols-2">
        <Field label={etiket} htmlFor={kimlik}>
          <TextInput
            id={kimlik}
            type="password"
            autoComplete="new-password"
            value={deger.parola}
            onChange={(e) => onDegis({ ...deger, parola: e.currentTarget.value })}
          />
        </Field>
        <Field label={M.kilit.parolaAlan.tekrar(etiket)} htmlFor={`${kimlik}-tekrar`}>
          <TextInput
            id={`${kimlik}-tekrar`}
            type="password"
            autoComplete="new-password"
            value={deger.tekrar}
            onChange={(e) => onDegis({ ...deger, tekrar: e.currentTarget.value })}
          />
        </Field>
      </div>
      {kisa && sart && (
        <Notice tone="warn" title={M.kilit.parolaAlan.kisaBaslik(PAROLA_UYARI_UZUNLUGU)}>
          <p>{M.kilit.parolaAlan.kisaSart(PAROLA_UYARI_UZUNLUGU)}</p>
        </Notice>
      )}
      {kisa && !sart && (
        <Notice tone="warn" title={M.kilit.parolaAlan.kisaBaslik(PAROLA_UYARI_UZUNLUGU)}>
          <p>{M.kilit.parolaAlan.kisaUyari}</p>
        </Notice>
      )}
    </div>
  );
}
